export const includeModeTypes = [
  {
    value: 'HEADER',
    title: 'Header',
  },
  {
    value: 'URL_PARAMETER',
    title: 'URL Parameter',
  },
];

export const requestModes = [
  {
    value: 'GET',
    title: 'GET',
  },
  {
    value: 'POST',
    title: 'POST',
  },
  {
    value: 'PUT',
    title: 'PUT',
  },
];

export const responseFormats = [
  {
    value: 'xml',
    title: 'XML',
  },
  {
    value: 'json',
    title: 'JSON',
  },
  {
    value: 'plain',
    title: 'PLAIN',
  },
];

export const responseFormatsCSV = [
  {
    value: 'csv',
    title: 'CSV',
  },
  {
    value: 'json',
    title: 'JSON',
  },
  {
    value: 'txt',
    title: 'TEXT',
  },
  {
    value: 'xml',
    title: 'XML',
  },
];

export const signatureMethods = [
  {
    value: 'PLAINTEXT',
    title: 'PLAINTEXT',
  },
  {
    value: 'HMAC-SHA1',
    title: 'HMAC-SHA1',
  },
  {
    value: 'HMAC-SHA256',
    title: 'HMAC-SHA256',
  },
];

export const exchangeTypes = [
  {
    value: '2-legged',
    title: '2-Legged',
  },
  {
    value: '3-legged',
    title: '3-Legged',
  },
];

export const authTypes = [
  {
    value: 'NONE',
    title: 'No Auth',
  },
  {
    value: 'API_KEY',
    title: 'Api Key',
  },
  {
    value: 'AWS_SIGNATURE',
    title: 'AWS Signature',
  },
  {
    value: 'BASIC',
    title: 'Basic',
  },
  {
    value: 'OAUTH1',
    title: 'OAuth1',
  },
  {
    value: 'OAUTH2',
    title: 'OAuth2',
  },
  {
    value: 'TOKEN',
    title: 'Token',
  },
];

export const paramDataTypes = [
  {
    value: 'string',
    title: 'String',
  },
  {
    value: 'integer',
    title: 'Integer',
  },
  {
    value: 'string_multi',
    title: 'Multiple Strings',
  },
  {
    value: 'frequency',
    title: 'Frequency',
  },
];

export const authPayloadModes = [
  {
    title: 'Encoded Header',
    description:
      'OAuth client id:secret information are attached as a Base-64 encoded pair to Authentication header',
    value: 'header',
  },
  {
    title: 'Form Data',
    description:
      'OAuth client id and secret information are attached as form data payload parameters',
    value: 'form',
  },
  {
    title: 'Query Parameters',
    description:
      'OAuth client id and secret information are attached as query parameters to the Token query',
    value: 'query',
  },
  {
    title: 'Skip Automatic Inclusion',
    description:
      'Only for 2-legged OAuth: With this option, OAuth client id and secret information are not automatically attached by the platform. Instead they should be explicity set in the \u0060OAuth2: Token Request Body\u0060. \n\nThis is not a commonly used option and is only to be used for API vendors where inclusion of client info in any other way is rejected by the vendor.',
    value: 'none',
  },
];

export const contentTypes = [
  { value: 'application/json', title: 'application/json' },
  { value: 'application/atom+xml', title: 'application/atom+xml' },
  {
    value: 'application/x-www-form-urlencoded',
    title: 'application/x-www-form-urlencoded',
  },
  {
    value: 'application/json;charset=UTF-8',
    title: 'application/json;charset=UTF-8',
  },
  { value: 'application/octet-stream', title: 'application/octet-stream' },
  { value: 'application/pdf', title: 'application/pdf' },
  { value: 'application/problem+json', title: 'application/problem+json' },
  {
    value: 'application/problem+json;charset=UTF-8',
    title: 'application/problem+json;charset=UTF-8',
  },
  { value: 'application/problem+xml', title: 'application/problem+xml' },
  { value: 'application/rss+xml', title: 'application/rss+xml' },
  { value: 'application/stream+json', title: 'application/stream+json' },
  { value: 'application/xhtml+xml', title: 'application/xhtml+xml' },
  { value: 'application/xml', title: 'application/xml' },
];

export const sinkContentTypes = [
  { value: 'application/json', title: 'application/json' },
  { value: 'application/xml', title: 'application/xml' },
];

export const algorithms = [
  { title: 'NONE', value: 'NONE' },
  { title: 'HS256', value: 'HS256' },
  { title: 'HS384', value: 'HS384' },
  { title: 'HS512', value: 'HS512' },
  { title: 'RS256', value: 'RS256' },
  { title: 'RS384', value: 'RS384' },
  { title: 'RS512', value: 'RS512' },
  { title: 'ES256', value: 'ES256' },
  { title: 'ES384', value: 'ES384' },
  { title: 'ES512', value: 'ES512' },
  { title: 'PS256', value: 'PS256' },
  { title: 'PS384', value: 'PS384' },
  { title: 'PS512', value: 'PS512' },
];

export const timeUnits = [
  { value: 'yyyy', title: 'Year' },
  { value: 'MM', title: 'Month' },
  { value: 'dd', title: 'Day' },
  { value: 'HH', title: 'Hour' },
  { value: 'mm', title: 'Minute' },
  { value: 'ss', title: 'Second' },
];

export const dateFormats = [
  {
    title: 'yyyy-MM-dd',
    value: 'yyyy-MM-dd',
    description: 'Year-Month-Date.Ex: 2020-04-24',
  },
  {
    title: 'MM/dd',
    value: 'MM/dd',
    description: 'Month/Date. Ex: 04/24',
  },
  {
    title: 'Year (2-digit)',
    value: 'yy',
    description: '2-digit Year. Ex: 04',
  },
  {
    title: 'Year (4-digit)',
    value: 'yyyy',
    description: '4-digit Year. Ex: 2020',
  },
  {
    title: 'Month (2-digit)',
    value: 'MM',
    description: '2 digit month. Ex: 04 = April',
  },
  {
    title: 'Month (3-letter)',
    value: 'MMM',
    description: '3 letter month. Ex: Apr',
  },
  {
    title: 'Month (full word)',
    value: 'MMMM',
    description: 'Month in year. Ex: April',
  },
  {
    title: 'Hour in am/pm (1-12)',
    value: 'hh',
    description: 'Hour (1-12).',
  },
  {
    title: 'Hour:Min (hh:mm)',
    value: 'hh:mm',
    description: 'Hour:Min in 12 hour format. Ex: 03:20',
  },
  {
    title: 'Hour of Day (0-23)',
    value: 'HH',
    description: 'Hour in 24 hour format. Ex: 17',
  },
  {
    title: 'HH:mm',
    value: 'HH:mm',
    description: 'Hour:Min in 24 hour format. Ex: 17:45 ',
  },
  {
    title: 'Day in year',
    value: 'DD',
    description: 'Day in year. Ex: 119',
  },
  {
    title: 'Unix Epoch Time (Milliseconds)',
    value: 'eeee',
    description: 'Unix epoch time in milliseconds. Ex:1588063912673',
  },
  {
    title: 'Unix Epoch Time (Seconds)',
    value: 'ssss',
    description: 'Unix epoch time in seconds. Ex: 1588063697',
  },
  {
    title: 'ISO-8601 date format',
    value: "yyyy-MM-dd'T'HH:mm:ss'Z'",
    description: "ISO-8601 date (yyyy-MM-dd'T'HH:mm:ss'Z'). Ex:2020-04-28T04:15:06-0500",
  },
];

export const resourceTypes = [
  { value: 'SOURCE', title: 'Source' },
  { value: 'SINK', title: 'Destination' },
];

export const dataTypes = [
  { value: 'int', title: 'Integer' },
  { value: 'string', title: 'String' },
  { value: 'string-multi', title: 'Multiple Strings' },
];

export const iterationTypes = [
  { value: 'static.url', title: 'static.url' },
  { value: 'data.map.key.queue', title: 'data.map.key.queue' },
  { value: 'paging.incrementing', title: 'paging.incrementing' },
  { value: 'paging.incrementing.offset', title: 'paging.incrementing.offset' },
  { value: 'paging.next.token', title: 'paging.next.token' },
  { value: 'paging.next.url', title: 'paging.next.url' },
  { value: 'link.header', title: 'link.header' },
  { value: 'response.id.number', title: 'response.id.number' },
  { value: 'response.id.string', title: 'response.id.string' },
  { value: 'graphql.page', title: 'graphql.page' },
  { value: 'graphql.cursor', title: 'graphql.cursor' },
  { value: 'async.poll', title: 'async.poll' },
  { value: 'body.as.file', title: 'body.as.file' },
];
